import { render, staticRenderFns } from "./PanelTable.vue?vue&type=template&id=c2b6b704&"
import script from "./PanelTable.vue?vue&type=script&lang=js&"
export * from "./PanelTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QIcon,QTr,QTh,QTd} from 'quasar'
component.options.components = Object.assign({QTable,QIcon,QTr,QTh,QTd}, component.options.components || {})
